import { getCurrentProject } from '../sessionManager';
import { slugify } from "$utils/string";
import store from "../store";

// En alguns casos és còmode tenir el nom a part de la descripció del paràmetre
export const addKeysAsField = (object, field="id") => Object.fromEntries([...Object.entries(object)].map(([key, value]) => [key, {...value, [field]: key}]));

export const findNoteIndexInSequence = (sequence, targetProperties) => {
    for (let i = 0; i < sequence.length; i++) {
        const note = sequence[i];
        let isMatch = true;
        for (const key in targetProperties) {
            if (note[key] !== targetProperties[key]) {
                isMatch = false;
                break;
            }
        }
        if (isMatch) return i;
    }
    return -1;
}

export const findNoteInSequence = (sequence, targetProperties) => sequence[findNoteIndexInSequence(sequence, targetProperties)];

// Util function to check if a beat is a swing beat
export const necessitaSwing = (numeroBeat) => {
    return ((numeroBeat - 2) % 4) == 0
}

// URL params utils

export const getURLParamValue = (paramName, defaultValue) => {
    var queryString = location.search
    let params = new URLSearchParams(queryString)
    if (!params.has(paramName)) {
        return defaultValue
    }
    return params.get(paramName)
}

export const removeURLParam = (paramName) => {
    let url = new URL(window.location.href)
    let params = new URLSearchParams(url.search.slice(1))
    if (params.has(paramName)) {
        params.delete(paramName)
        let newUrl = window.location.pathname;
        if (`${params}` !== '' || window.location.hash !== '') {
            newUrl += `?${params}${window.location.hash}`
        }
        window.history.replaceState(null, null, newUrl)
    }    
}

export const goToGruf = (grufId) => {
    if (grufId === "") return console.error("GRUFID is empty");
    const projectUrl = appPrefix + "/g/" + grufId;
    window.location.replace(projectUrl);
}

// Util function to return the display name of a clip

export const getClipDisplayName = (clipNumber) => {
    if (clipNumber === undefined) return "";
    // Returns the uppercase character corresponding to the clip number
    return String.fromCharCode(65 + clipNumber);
}

// Util function to get the current version info of GRUF
export const getAppVersionInfo = () => {
    return {
        version: appVersion,
        commit: appCommit,
    };  // Defined in base.html
}

// Get download audio recording filename

export const downloadedAudioRecordingFilename = () => {
    const date = new Date();
    return `GRUF_${getCurrentProject().getID()}_${slugify(getCurrentProject().getNom())}_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}.wav`;
}

export const removeKeyFromDictionary = (dictionary, key) => {
    var duplicate = Object.assign({}, dictionary);
    delete duplicate[key];
    return duplicate;
}

// https://stackoverflow.com/a/30800715
export function downloadObjectAsJson(object, baseName="object", extension=".json") {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(object, null, 2));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", baseName + extension);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

const makeSticky = (checkValidity, initial=null) => {
    let lastValid = initial;
    return value => {
        if (checkValidity(value)) lastValid = value;
        return lastValid;
    };
};

export const createStickySelector = (selector, checkValidity, initial=null) => {
    const sticky = makeSticky(checkValidity, initial);

    return (state, ...args) => {
        const current = selector(state, ...args);
        return sticky(current);
    };
};
// Collects all the data of the project and returns it as an object that should be suitable to be stored in a redis store
// It has information that probably shouldn't be stored
const getFullProjectDataObject = () => store.getState().project;

export function getProjectDataObject() {
    const projectObject = structuredClone(getFullProjectDataObject()); // so that we can delete properties, because og object is frozen
    delete projectObject.transport;
    delete projectObject.audio;
    delete projectObject.metadata.connected_users;
    return projectObject;
}

export const sleep = (ms, signal) => {
    let abort;
    const promise = new Promise((resolve, reject) => {
        const done = function() {
            resolve();
            signal?.removeEventListener("abort", abort);   
        }
        abort = function() {
            reject();
            clearTimeout(timeoutID);
        }
        const timeoutID = setTimeout(done, ms);
        signal.addEventListener("abort", abort);
    });
    promise.abort = abort;
    return promise;
}